import { render, staticRenderFns } from "./UB04Claim.vue?vue&type=template&id=79336027&scoped=true"
import script from "./UB04Claim.vue?vue&type=script&lang=js"
export * from "./UB04Claim.vue?vue&type=script&lang=js"
import style0 from "./UB04Claim.vue?vue&type=style&index=0&id=79336027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79336027",
  null
  
)

export default component.exports